import classNames from "classnames";
import { ButtonHTMLAttributes } from "react";
import styles from "./index.module.scss";

type AdminButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

type GhostButtonProps = AdminButtonProps & {
  /** Destructive ghost action: --status-danger-fg text instead of the neutral ink. */
  danger?: boolean;
};

/**
 * Light secondary action (bordered pill) — complements the shared ui/Button,
 * which stays the primary action everywhere in the console.
 */
export function GhostButton({ className, type, danger, ...rest }: GhostButtonProps) {
  return (
    <button
      type={type ?? "button"}
      className={classNames(styles.ghost, danger && styles.ghostDanger, className)}
      {...rest}
    />
  );
}

/** Filled destructive action for delete confirmations. */
export function DangerButton({ className, type, ...rest }: AdminButtonProps) {
  return (
    <button
      type={type ?? "button"}
      className={classNames(styles.danger, className)}
      {...rest}
    />
  );
}
